import { ValidationType } from "@/validation";

import { IEverbrightLocaleMessages } from "./IEverbrightLocaleMessages";

/**
 * Vue-i18n locale object to store messages for Spanish.
 * See EverbrightLocale.ts before adding anything here.
 */
export const spanishMessages: IEverbrightLocaleMessages = {
    "common": {
        "next": "Continuar",
        "all-rights-reserved": "Todos los derechos reservados",
        "espired": "eSpired",
        "contact-us": "Contáctanos",
        "terms-of-use": "Términos de uso",
        "privacy-policy": "Política de privacidad",
        "corporate-site": "Sitio web corporativo de eSpired",
        "yes": "Sí",
        "no": "No",
        "ok": "Está bien",
        "credit-card": "Tarjeta de crédito",
        "debit-card": "Tarjeta de débito"
    },

    "step1": {
        header: "Paso 1 de 2: Introduce tu dirección de correo electrónico"
    },

    "step2": {
        "shipping-information": "Información de envío",

        "billing-information": "Información de cobro",

        "agree-to-terms":
            "Debes acceder a los términos y condiciones para poder continuar",

        "what-is-this": "¿Qué es esto?",

        "terms-and-conditions-header": "Términos y condiciones de esta oferta",

        "payment-information": "Información de pago",

        "order-processing-description":
            "Por favor no cerrar el navegador o refrescar la página mientras la orden se está procesando, ya que esto puede interferir con el éxito de la orden.",

        "order-processing-time":
            "El tiempo de procesamiento puede tomar entre 10 y 15 segundos.",

        "invalid-shipping-address":
            "Has proporcionado una dirección de envío inválida",

        "detected-different-address":
            "Hemos detectado un formato diferente para la dirección de envío que ingresaste:",

        "you-entered": "Tú ingresaste:",

        "updated-address": "Dirección actualizada:",

        "use-updated-address": "¿Quieres utilizar la dirección actualizada?",

        "process-order": "Procesar Orden",

        "invalid-credit-card": "Este número de tarjeta no es válido.",

        "credit-card-expired": "Esta tarjeta ha caducado."
    },

    "organizationSponsorshipStep2": {
        "shipping-information": "Shipping Information for School/Organization",

        "billing-information": "Sponsor Billing Information",
    },

    "shopping-cart": {
        "header": "Tu carrito de compras",
        "order-total": "Total de la orden",
        "order-tax": "Impuesto",
        "order-shipping": "Costo de envío",
        "cost-free": "GRATIS",
        "your-order-detail": "Tu orden pormenorizada",
        "items-pending-approval": "Artículos pendientes de aprobación",
        "shipping-and-processing": "Envío y procesamiento ◊",
        "order-number": "Orden #",
        "free-just-pay-shipping":
            "Gratis (solo paga de envío y procesamiento ◊)",
        "shipping-processing-free":
            "(El envío y el procesamiento son gratuitos ◊)",

        "all-soft-declined": (messageContext): string =>
            ` <p> Gracias por tu interés. </p><p> Hemos encontrado un problema con tu tarjeta de crédito, pero continuaremos haciendo intentos de procesar tu orden. Si tenemos éxito, te enviaremos un correo electrónico de confirmación. </p><p> Si tienes cualquier pregunta, por favor llama al ${messageContext.named(
                "brandCustomerServicePhone"
            )}. </p>`,

        "some-soft-declined": (messageContext): string =>
            ` <p> Hemos encontrado un problema con tu tarjeta de crédito, y no podemos cargar ciertos artículos a tu orden, tal como se listan a continuación. </p><p> Continuaremos haciendo intentos de procesar los artículos restantes en tu orden. Si tenemos éxito, te enviaremos un correo electrónico de confirmación. </p><p> Si tienes alguna pregunta, por favor llama al ${messageContext.named(
                "brandCustomerServicePhone"
            )} </p>`
    },

    "cvv-modal": {
        header: "¿Qué es el código de seguridad CVV?",
        text:
            " <p> El Código de seguridad CVV es el número de identificación de seguridad de tu tarjeta (también llamado “código de verificación”), y consiste en un número de tres o cuatro dígitos impreso en la mayoría de las principales tarjetas de crédito o débito. </p><h5> ¿Por qué solicitamos identificaciones de seguridad de las tarjetas? </h5> <p> Nosotros pedimos la identificación de seguridad de la tarjeta para fortalecer la seguridad de tu transacción. El número de identificación aparece en la propia tarjeta, y al solicitar este número, estamos ayudando a que el usuario de la tarjeta tiene de hecho la tarjeta consigo. Esta práctica reduce las probabilidades de que una persona no autorizada esté utilizando fraudulentamente tu tarjeta de débito o crédito. Nosotros no guardamos permanentemente códigos de seguridad de tarjetas en nuestro sistema. Nosotros pedimos el código de seguridad siempre que un cliente utiliza una tarjeta de crédito o débito para adquirir artículos en línea. </p><h5> ¿Dónde puedo encontrar el código de seguridad? </h5> <p> Puedes encontrar el código de seguridad de la tarjeta en la parte de atrás de las tarjetas de crédito o débito MasterCard, Visa y Discover. Es un grupo separado de 3 dígitos en o a la derecha de la franja de la firma. En tarjetas American Express, el código de seguridad de la tarjeta es un grupo de 4 dígitos impresos (no grabados) en el frente hacia la derecha de la tarjeta. </p> <h5>¿Qué pasa si mi tarjeta no tiene código de seguridad?</h5> <p>No todas las tarjetas de crédito o débito tienen un número de identificación de seguridad. Si tu tarjeta no tiene uno, por favor deja la casilla de texto del ‘Código de seguridad de la tarjeta’ en blanco.</p> <p>¿Qué pasa si no puedo leer el código de seguridad de la tarjeta?</p><p>Si tu tarjeta tiene un código de seguridad pero no puedes leerlo, no puedes utilizar esa tarjeta para completar la transacción. Por favor, contacta al emisor de la tarjeta de débito o crédito para recibir asistencia con la tarjeta problemática, o utiliza otra tarjeta.</p>"
    },

    "upsell-modal": {
        yes: "Sí, por favor añade esto a mi orden"
    },

    "promotionOrderModel": {
        shippingFirstName: "Nombre del destinatario",
        shippingLastName: "Apellido del destinatario",
        shippingAddress: "Dirección de la calle del destinatario",
        shippingAddress2: "Dirección de la calle del destinatario 2",
        shippingCity: "Ciudad del destinatario",
        shippingState: "Estado",
        shippingZipCode: "Código Postal",
        shippingPhone: "Teléfono del destinatario",
        billingFirstName: "Nombre",
        billingLastName: "Apellido",
        billingAddress: "Dirección de la calle de facturación",
        billingAddress2: "Dirección de la calle de facturación 2",
        billingCity: "Ciudad",
        billingState: "Estado",
        billingZipCode: "Código postal",
        billingPhone: "Teléfono",
        acceptedTermsAndConditions:
            "Yo confirmo que tengo más de 18 años y que he leído y estoy de acuerdo con los términos y condiciones de esta oferta.",
        paymentMethod: "Escoger método de pago",
        cardNumber: "Número de la tarjeta",
        expirationDateMonth: "Mes de vencimiento",
        expirationDateYear: "Año de vencimiento",
        cvvCode: "Código de seguridad",
        billingAddressSameAsShipping:
            "¿La dirección de cobro es la misma que la dirección de envío?",
        repId: "Identificación del representante",
        email: "Correo electrónico"
    },

    "organizationSponsorshipPromotionOrderModel": {
        shippingFirstName: "Recipient School/Organization",
        shippingAddress: "Street Address",
        shippingAddress2: "Contact Name",
        shippingCity: "City",
        shippingState: "State",
        shippingZipCode: "Zip Code",
        shippingPhone: "Phone"
    },

    "validation": {
        // These are validation messages for `vee-validate`
        // Validation messages are checked for here first, if they're not found the default one from vee-validate's locale is used.

        // These messages are in vee-validate's format:
        //      https://logaretm.github.io/vee-validate/guide/localization.html#adding-messages

        // Add validation messages from "RM6406 - Spanish Translations":
        [ValidationType.required]: "Se requiere llenar {_field_}",

        [ValidationType.minimum]:
            "El campo {_field_} debe tener al menos {length} caracteres",

        [ValidationType.maximum]:
            "El campo {_field_} no debe ser mayor a {length} caracteres",

        [ValidationType.between]:
            "El campo {_field_} debe estar entre {min} y {max}",

        // "You must enter a valid email address" (no field name required)
        [ValidationType.email]:
            "Debe ingresar una dirección de correo electrónico válida",

        [ValidationType.confirmed]: "El campo {_field_} no coincide",

        [ValidationType.regex]: "El formato del nombre {_field_} es inválido"
    },

    "server-validation": {
        promotionOrderModel: {
            cardNumber:
                "El 'número de tarjeta' no es un número de tarjeta de crédito válido"
        },
        maxMindInvalidOrder:
            "Corrija su información y vuelva a enviar su pedido. (MM)"
    }
};
